document.addEventListener("DOMContentLoaded", function () {
    const viewOptions = document.querySelectorAll('input[name="grid-mobile"]');
    const storageKey = "grid-mobile-selection";

    const saveOption = localStorage.getItem(storageKey);
    if (saveOption) {
      const savedRadio = document.querySelector(
        `input[name="grid-mobile"][value="${saveOption}"]`
      );
      if (savedRadio) {
        savedRadio.checked = true;
      }
    }

    viewOptions.forEach((radio) => {
      radio.addEventListener("change", function () {
        localStorage.setItem(storageKey, this.value);
      });
    });
  });